<template>
  <v-app>
    <v-app-bar app color="primary" dark flat>
      <!-- title -->
      <v-toolbar-title>
        <router-link to="/">SAV Terms</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- light / dark -->
      <v-btn icon @click="$vuetify.theme.dark = !$vuetify.theme.dark">
        <v-icon>mdi-brightness-6</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
.v-toolbar__title a {
  color: #ffffff !important;
  text-decoration: none !important;
}
* {
  word-break: break-word !important;
}
</style>